import React from 'react';
import { FolderOpenOutlined, PlusSquareOutlined } from '@ant-design/icons';
import { FolderListItem, PathItem } from './styles';
export default function MoveFolderItem({
  expandThisDir,
  hasSubdirs,
  isLoading,
  name,
  path,
  selectThisDir,
  selectedPath
}) {
  const onClickExpandBtn = e => {
    e.stopPropagation();
    expandThisDir();
  };
  const btnStyle = {};
  if (isLoading) btnStyle['color'] = 'gray';
  return <FolderListItem className={path === selectedPath && 'active'} onClick={selectThisDir} data-testid="doc-move-folder-item">
      <FolderOpenOutlined style={{
      color: '#333'
    }} />
      <PathItem>{name}</PathItem>
      {hasSubdirs && <PlusSquareOutlined style={btnStyle} onClick={onClickExpandBtn} />}
    </FolderListItem>;
}